module.exports = __webpack_public_path__ + "static/6@3x-0cb8c65b6d00434e74c7c7b66485148c.png";